export class AttachmentHelper {

    public static getFilesize(url: string) {
        return new Promise<string>((resolve) => {
            const xhr = new XMLHttpRequest();
            xhr.open("HEAD", url, true); // Notice "HEAD" instead of "GET",
            //  to get only the header
            xhr.onreadystatechange = () => {
                if (xhr.readyState == xhr.DONE) {
                    const result = AttachmentHelper.formatBytes(parseInt(xhr.getResponseHeader("Content-Length")));
                    resolve(result);
                }
            };
            xhr.send();
        });
    }

    public static formatBytes(bytes: number, decimals: number = 2): string {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
}